
<template>
 <Profile></Profile>
            
</template>
 

<script setup>
import Profile from '~/components/leyoutsCustomer/common/Profile'
 
     

</script>

